import * as React from "react";
import Navbar from '../shared/Navbar';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useHistory } from "react-router";
import Typography from "@material-ui/core/Typography";

const useStylesNav = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        backgroundColor: '#0049a3'
    },
    logo: {

        display: "flex",
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    logoImg: {
        width: 236,
    },
    navBarElements: {
        fontSize: '18'
    },
    toolbar: {
        padding: 0,
        height: 59,
    },
    leftHandMenu: {
        height: '100%'
    },
    rightHandMenu: {
        height: '100%',
        display: "flex",
        justifyContent: "flex-end"
    },
    rightHandMenuButton: {
        color: '#fff',
    },
    heading: {
        paddingLeft: 40,
        paddingTop: 40,
        fontSize: '40px',
        fontWeight: 900
    },
    textBody: {
        padding: 40,
        fontSize: '18px'
    }
}));

function TermsAndConditions() {
    const classes = useStylesNav();
    const history = useHistory();
    return (
        <React.Fragment >
            <Navbar humberMenu={<div className={classes.leftHandMenu}> <Button style={{ height: '100%', color: '#FFF', display: 'flex', justifyContent: 'flex-start' }} onClick={() => { history.goBack() }} startIcon={<ArrowBackIosIcon />} >Sign Up</Button></div>} />
            <div>
                <div className={classes.heading}>
                    Terms Of Use
                </div>

                <Typography component="div" className={classes.textBody}>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </Typography>
            </div>
        </React.Fragment >
    );
}

export default React.memo(TermsAndConditions);